import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { RecipeStatus } from '@/api/types'
import { foodRestrictionsQuery, tagsQuery } from '@/api'
import RecipeIndex from '@/features/recipes/RecipeIndex'
import { adminsAndAmbassadorsQuery } from '@/api/users'
import { ExpertiseLevel } from '@/features/recipes/constants'

export type RecipesSearch = {
  page?: number
  pageSize?: number
  searchText?: string
  idIngredient?: number
  ingredientName?: string
  tagName?: string[]
  noMealTypes?: boolean
  noSeasons?: boolean
  authorId?: number
  suitableDiet?: string[]
  suitableFoodRestrictionID?: string[]
  status?: RecipeStatus
  cuisine?: string
  expertiseLevel?: ExpertiseLevel[]
  maxPreparationTime?: number
  maxCookingTime?: number
  minKcal?: number
  maxKcal?: number
  minProteinRatio?: number
  maxProteinRatio?: number
  minFatRatio?: number
  maxFatRatio?: number
  minCarbsRatio?: number
  maxCarbsRatio?: number
  minServings?: number
  maxServings?: number
  sortField?: string
  sortDirection?: string
  lang?: string
  photoFilter?: string
}

export const Route = createFileRoute('/recipes')({
  loader: async ({ context: { queryClient } }) => {
    const [tags, allergens, authors] = await Promise.all([
      queryClient.ensureQueryData(tagsQuery),
      queryClient.ensureQueryData(foodRestrictionsQuery),
      queryClient.ensureQueryData(adminsAndAmbassadorsQuery),
    ])

    return {
      tags,
      allergens,
      authors,
    }
  },
  component: RecipesComponent,
  validateSearch: (search: Record<string, unknown>): RecipesSearch => {
    // validate and parse the search params into a typed state
    return {
      page: search.page as number,
      idIngredient: search.idIngredient as number,
      ingredientName: search.ingredientName as string,
      searchText: search.searchText as string,
      tagName: search.tagName as string[],
      authorId: search.authorId as number,
      suitableDiet: search.suitableDiet as string[],
      suitableFoodRestrictionID: search.suitableFoodRestrictionID as string[],
      cuisine: search.cuisine as string,
      expertiseLevel: search.expertiseLevel as ExpertiseLevel[],
      minKcal: search.minKcal as number,
      maxKcal: search.maxKcal as number,
      sortField: search.sortField as string,
      sortDirection: search.sortDirection as string,
      lang: search.lang as string,
      photoFilter: search.photoFilter as string,
    }
  },
})

function RecipesComponent() {
  const { tags, allergens, authors } = Route.useLoaderData()

  return <RecipeIndex tags={tags} allergens={allergens} authors={authors} />
}

export const recipesRoute = Route
